import { Component, OnInit } from '@angular/core';
import { GeofenceService } from '@app-asset-config/services/geofence.service';
import { DataService } from '@app-core/services/data/data.service';

@Component({
  selector: 'app-geofence-home',
  templateUrl: './geofence-home.component.html',
  styleUrls: ['./geofence-home.component.scss'],
})
export class GeofenceHomeComponent implements OnInit {
  public activeTab: string;

  // geofence setting related variables
  public geofenceSettingList: any[] = [];

  constructor(private geofenceService: GeofenceService, public dataService: DataService) {}

  ngOnInit(): void {
    this.setActiveTab('geofence');

    this.geofenceService.commonDataBus.next({ event: 'SHOW_HOME' });
  }

  // when clicked on tab
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
}
